import { ReactNode } from 'react';
import {
  StyledBlock,
  StyledDescription,
  StyledHeader,
  StyledSection,
  StyledSuptitle,
  StyledTitle,
} from './HeaderStyles';

type IHeaderProps = {
  children?: ReactNode;
  title: ReactNode;
  suptitle?: ReactNode;
  description?: ReactNode;
};

const Header = ({ children, title, suptitle, description }: IHeaderProps) => {
  return (
    <StyledHeader>
      <StyledSection>
        <StyledBlock>
          {!!suptitle && <StyledSuptitle>{suptitle}</StyledSuptitle>}
          <StyledTitle>{title}</StyledTitle>
          {!!description && <StyledDescription>{description}</StyledDescription>}
        </StyledBlock>
        {children}
      </StyledSection>
    </StyledHeader>
  );
};

export default Header;
